import React, { memo } from 'react';
import styles from './Image.module.less';
// import { Link } from 'react-router-dom';

export default memo(({ data: { imgUrl } }) => {
  return (
    <>
      {imgUrl && <img className={styles.image} src={imgUrl} alt="" />}
      {!imgUrl && <div className={styles.image} />}
    </>
  );
});
